import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ToastrModule } from 'ngx-toastr';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedComponentsModule } from './components/shared-components.module';
import { SharedDirectivesModule } from './directives/shared-directives.module';
import { SharedPipesModule } from './pipes/shared-pipes.module';
import { MatInputModule } from '@angular/material/input';
import { DateAdapter, ErrorStateMatcher as MaterialErrorStateMatcher, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatRadioModule } from '@angular/material/radio';
import {MatTimepickerModule} from '@angular/material/timepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ErrorStateMatcher } from './config/error-state-matcher';
import { FileUploadModule } from 'ng2-file-upload';
import { CURRENCY_MASK_CONFIG, CurrencyMaskConfig, CurrencyMaskModule } from 'ng2-currency-mask';
import { DateFormatAdapter, PICK_FORMATS } from './config/date-format-adapter';
import { PaginatorPtbr } from './config/paginator';
import { ButtonsModule } from './components/buttons/buttons.module';
import { SharedFormsModule } from './forms/shared-forms.module';
import { MatButtonModule } from '@angular/material/button';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatDialogModule } from '@angular/material/dialog';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FilterModule } from './filter/filter.module';
import { CheckBoxModule } from './components/checkbox/checkbox.module';
// import { Daterangepicker } from 'ng2-daterangepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTableModule } from '@angular/material/table';
import { NgxDaterangepickerBootstrapModule } from 'ngx-daterangepicker-bootstrap';
export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
	align: 'left',
	allowNegative: true,
	decimal: ',',
	precision: 2,
	prefix: 'R$ ',
	suffix: '',
	thousands: '.'
};

const imports = [
	CommonModule,
	ToastrModule.forRoot(),
	NgbModule,
	SharedComponentsModule,
	SharedDirectivesModule,
	SharedPipesModule,
	RouterModule,
	FileUploadModule
];

const exportsComponents = [
	NgxDaterangepickerBootstrapModule,
	FileUploadModule,
	SharedFormsModule,
	CurrencyMaskModule,
	FormsModule,
	MatCheckboxModule,
	MatDatepickerModule,
	MatPaginatorModule,
	MatIconModule,
	MatInputModule,
	MatRadioModule,
	MatSelectModule,
	MatTimepickerModule,
	MatSlideToggleModule,
	MatTabsModule,
	MatTooltipModule,
	MatButtonModule,
	MatChipsModule,
	MatAutocompleteModule,
	NgxMatSelectSearchModule,
	NgbModule,
	ReactiveFormsModule,
	SharedComponentsModule,
	SharedDirectivesModule,
	SharedPipesModule,
	MatDialogModule,
	ButtonsModule,
	FilterModule,
	CheckBoxModule,
	MatFormFieldModule,
	MatTableModule,
];

const providers = [
	{ provide: MaterialErrorStateMatcher, useClass: ErrorStateMatcher },
	{ provide: DateAdapter, useClass: DateFormatAdapter },
	{ provide: MAT_DATE_FORMATS, useValue: PICK_FORMATS },
	{ provide: MatPaginatorIntl, useClass: PaginatorPtbr },
	{ provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig }
];

@NgModule({
	declarations: [],
	imports,
	exports: exportsComponents,
	providers
})
export class SharedModule {}
